import { render } from "./fbx-textarea.vue?vue&type=template&id=e39c378c&scoped=true"
import script from "./fbx-textarea.vue?vue&type=script&lang=js"
export * from "./fbx-textarea.vue?vue&type=script&lang=js"

import "./fbx-textarea.vue?vue&type=style&index=0&id=e39c378c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39c378c"]])

export default __exports__